<template>
  <div>
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          v-if="
            params &&
            params.context &&
            params.context.parentComponent &&
            params.context.parentComponent.permissions &&
            params.context.parentComponent.permissions.change
          "
          class="mr-4 ml-1"
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="editItem"
        >
          mdi-pencil
        </v-icon>
      </template>
      <span>Edit</span>
    </v-tooltip>

    <v-tooltip bottom v-if="params.data.is_active == 'Yes'">
      <template #activator="{ on, attrs }">
        <v-icon
          class="ml-2 mr-1"
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="deactivate"
          v-if="
            params &&
            params.context &&
            params.context.parentComponent &&
            params.context.parentComponent.permissions &&
            params.context.parentComponent.permissions.add
          "
        >
          mdi-close
        </v-icon>
      </template>
      <span>DeActivate</span>
    </v-tooltip>
    <v-tooltip bottom  v-if="params.data.is_active == 'No'">
      <template #activator="{ on, attrs }">
        <v-icon
          class="ml-2 mr-1"
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="activate"
          v-if="
            params &&
            params.context &&
            params.context.parentComponent &&
            params.context.parentComponent.permissions &&
            params.context.parentComponent.permissions.add
          "
        >
          mdi-check
        </v-icon>
      </template>
      <span>Activate</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    editItem() {
      this.params.context.parentComponent.editCheckList(this.params.data.id);
    },
    deactivate() {
      this.params.context.parentComponent.activateDeactivateCheckListData(
        this.params.data.id, 'deactivate'
      );
    },
    activate() {
      this.params.context.parentComponent.activateDeactivateCheckListData(
        this.params.data.id, 'activate'
      );
    },
  },
};
</script>

<style></style>
